import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`dark-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        <div className="logo-container" onClick={() => scrollToSection('hero')}>
          <h1 className="logo-text">SYGMATEC</h1>
        </div>

        <nav className={`dark-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <button className="dark-nav-link" onClick={() => scrollToSection('about')}>
            About
          </button>
          <button className="dark-nav-link" onClick={() => scrollToSection('solutions')}>
            Solutions
          </button>
          <button className="dark-nav-link" onClick={() => scrollToSection('themes')}>
            Themes
          </button>
          <a href="/about" className="dark-nav-link">
            About Us
          </a>
        </nav>

        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <button className="mobile-nav-link" onClick={() => scrollToSection('about')}>
            About
          </button>
          <button className="mobile-nav-link" onClick={() => scrollToSection('solutions')}>
            Solutions
          </button>
          <button className="mobile-nav-link" onClick={() => scrollToSection('themes')}>
            Themes
          </button>
          <a href="/about" className="mobile-nav-link">
            About Us
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
